var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-layout flex-vert"},[_c('header',{staticClass:"page-header"},[_vm._t("page-header")],2),_c('div',{ref:"ebsBody",staticClass:"ebs-body flex-space ebs-content"},[_vm._t("ebs-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }